/** Public runtime configuration (Vite env). Secrets never live here. */
function req(name: string, fallback?: string): string {
  const v = (import.meta.env as Record<string, string | undefined>)[name] ?? fallback;
  if (v == null || v === '') throw new Error(`Missing env ${name}`);
  return v;
}

export const config = {
  supabaseUrl: req('VITE_SUPABASE_URL'),
  supabasePublishableKey: req('VITE_SUPABASE_PUBLISHABLE_KEY'),
  posthogKey: (import.meta.env.VITE_POSTHOG_API_KEY as string | undefined) ?? '',
  posthogHost: (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com',
  crispWebsiteId: (import.meta.env.VITE_CRISP_WEBSITE_ID as string | undefined) ?? '',
  privacyUrl: req('VITE_PRIVACY_URL', 'https://www.apptricksstudio.com/detectea/privacy'),
  termsUrl: req('VITE_TERMS_URL', 'https://www.apptricksstudio.com/detectea/terms'),
  mediaBase: req('VITE_MEDIA_BASE', '/media'),
  isDev: import.meta.env.DEV,
} as const;
